import { FC } from "react";

import { ElProps } from "@Shared/types";
import { AnimationFadeInBlur, AnimationFadeInGradientMask, Text } from "@Shared/ui";
import { twcx } from "@Shared/utils";

export type SuccessProps = ElProps<"div">;

export const Success: FC<SuccessProps> = ({ className, ...restProps }) => {
    return (
        <div className={twcx("flex flex-col items-center gap-2 text-center", className)} {...restProps}>
            <AnimationFadeInGradientMask>
                <Text as="h2" variant="h2" weight={600}>
                    Thank you!
                </Text>
            </AnimationFadeInGradientMask>

            <AnimationFadeInBlur delay={0.5}>
                <Text className="lg:text-body" as="p" variant="body-small">
                    Your submission has been received!
                </Text>
            </AnimationFadeInBlur>
        </div>
    );
};
